
























































import {
  defineComponent,
  computed,
  ref,
  onMounted,
} from '@vue/composition-api';
import store from '@/store';
import { CalcDiscountStatusEnum } from '@/api/apply-product/types';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import SelectCoupon from '../select-coupon';
import MarketingAmount from '../marketing-amount/index.vue';
import TempAmount from '../temp-amount/index.vue';

/** 优惠折扣模块 */
export default defineComponent({
  name: 'DiscountModule',
  components: {
    SelectCoupon,
    MarketingAmount,
    TempAmount,
  },
  setup(props) {
    const coupon = computed(() => store.state.applyProduct.coupon);
    const planListData = computed(() => store.state.applyProduct.planListData);
    const isDiscountModuleExperiment = computed(() => store.getters['applyProduct/isDiscountModuleExperiment'] && store.getters['applyProduct/showCouponModule']);

    /** 是否折叠 */
    const isFold = ref(false);

    /** 切换折叠状态 */
    const toggleFold = () => {
      isFold.value = !isFold.value;
      ubtSetupPageButton('finance_loan_apply_discountModule_fold', {
        fold: isFold.value ? '1' : '0',
      });
    };

    /** 计算折扣状态 */
    const calcDiscountStatus = computed(() => {
      if (planListData.value) {
        if (planListData.value.totalDiscountAmount) {
          return {
            status: CalcDiscountStatusEnum.CALC_DISCOUNT_AMOUNT,
            text: `-¥${planListData.value.totalDiscountAmount}`,
          };
        }
        return {
          status: CalcDiscountStatusEnum.NO_CALC_DISCOUNT_AMOUNT,
          text: '已享优惠',
        };
      }
      return {
        status: CalcDiscountStatusEnum.LOADING,
        text: '加载中...',
      };
    });

    onMounted(() => {
      ubtSetupModuleExpose('finance_loan_apply_discountModule', {
        type: isDiscountModuleExperiment.value ? 'discountModuleExperiment' : '  marketingAmountExperiment',
      });
    });

    return {
      coupon,
      planListData,
      isDiscountModuleExperiment,
      calcDiscountStatus,
      CalcDiscountStatusEnum,
      isFold,
      toggleFold,
    };
  },
});
